import React, { useEffect } from 'react';
import './About.css'
import Navbar from '../Menus/Navbar'
import Footer from '../Menus/Footer'
import AOS from 'aos';

import { FaTools, FaHandshake, FaUsers, FaLightbulb } from 'react-icons/fa';
export default function About() {
    useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  return (
    <>
    <Navbar/>


 <section id="about-home-appliance" className="about-section">
      <div className="container" data-aos="fade-up">
        <h2 className="section-title">About Home Appliance Assist</h2>
        <p className="subtitle">Your trusted partner in home appliance care.</p>

        <div className="intro">
          <h3>Welcome to Home Appliance Assist</h3>
          <p>
            At Home Appliance Assist, we are passionate about keeping your home appliances running smoothly. With years of experience and a commitment to excellence, we offer a comprehensive range of services designed to meet all your appliance needs.
          </p>
        </div>

        <div className="who-we-are" data-aos="fade-right">
          <h3>Who We Are</h3>
          <p>
            Founded on the principles of trust and quality, our team of certified technicians is skilled in repairing and maintaining a variety of home appliances, including washing machines, refrigerators, air conditioners, and more.
            We provide prompt, reliable, and effective solutions to get your appliances back in top condition.
          </p>
        </div>

        <div className="team-section" data-aos="fade-left">
          <h3>Meet Our Team</h3>
          <div className="team-grid">
            <div className="team-card">
              <h4>Prem</h4>
              <p>Lead Technician with 15+ years of experience. Expert in complex issues.</p>
            </div>
            <div className="team-card">
              <h4>Saravanan</h4>
              <p>Senior Technician with vast appliance knowledge and great customer care.</p>
            </div>
            <div className="team-card">
              <h4>Karthick</h4>
              <p>Specialist in installation and maintenance. Ensures efficient setup.</p>
            </div>
          </div>
        </div>

        <div className="approach" data-aos="fade-up">
          <h3>Our Approach</h3>
          <ul>
            <li><strong>Assessment:</strong> Complete appliance diagnostics.</li>
            <li><strong>Transparent Quotes:</strong> Honest, upfront pricing.</li>
            <li><strong>High-Quality Repairs:</strong> Only top-grade tools and parts.</li>
            <li><strong>Follow-Up:</strong> Post-repair support to ensure satisfaction.</li>
          </ul>
        </div>

        <div className="values" data-aos="fade-up">
          <h3>Our Values</h3>
          <div className="value-cards">
            <div className="value-card"><FaHandshake /> <span>Integrity</span></div>
            <div className="value-card"><FaUsers /> <span>Customer Focus</span></div>
            <div className="value-card"><FaTools /> <span>Excellence</span></div>
            <div className="value-card"><FaLightbulb /> <span>Innovation</span></div>
          </div>
        </div>

        <div className="reviews" data-aos="fade-up">
          <h3>What Our Clients Say</h3>
          <blockquote>“Home Appliance Assist provided excellent service when my washing machine broke down. Prompt and professional!” — <strong>Madhan</strong></blockquote>
          <blockquote>“Great experience. Team fixed my fridge quickly. Highly recommend!” — <strong>Vijay</strong></blockquote>
          <blockquote>“Fast, reliable, and affordable! Always top-notch service.” — <strong>Vasu</strong></blockquote>
        </div>
      </div>
    </section>




    <Footer/>
    
    
    
    </>
  )
}
